import { useDispatch, useSelector } from "react-redux";
import { setDevice } from "../store/reducers/device";
import { generateRandomFingerprint } from "../utils/helper";
import { useEffect } from "react";

const useDevice = () => {
	const dispatch = useDispatch();
	const device = useSelector((state) => state.device);

	useEffect(() => {
		const init = async () => {
			if (device?.device_id) {
				return;
			}

			const fingerprint = await generateRandomFingerprint();

			dispatch(
				setDevice({
					device_id: fingerprint,
					createdAt: new Date().toISOString(),
				}),
			);
		};

		init();
	}, [device, dispatch]);

	return device?.device_id || null;
};

export default useDevice;
